export const STAGE_WIDTH = 1920;
export const STAGE_HEIGHT = 1080;

export interface StageLayoutHandle {
  destroy(): void;
}

export function attachStageLayout(stage: HTMLElement, portraitOverlay: HTMLElement): StageLayoutHandle {
  stage.style.position = 'absolute';
  stage.style.top = '0';
  stage.style.left = '0';
  stage.style.width = `${STAGE_WIDTH}px`;
  stage.style.height = `${STAGE_HEIGHT}px`;
  stage.style.transformOrigin = 'top left';

  const applyLayout = (): void => {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const isPortrait = vw < vh;
    portraitOverlay.dataset.visible = isPortrait ? 'true' : 'false';

    const scale = Math.min(vw / STAGE_WIDTH, vh / STAGE_HEIGHT);
    const offsetX = (vw - STAGE_WIDTH * scale) / 2;
    const offsetY = (vh - STAGE_HEIGHT * scale) / 2;
    stage.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`;
  };

  applyLayout();
  window.addEventListener('resize', applyLayout);
  window.addEventListener('orientationchange', applyLayout);

  return {
    destroy() {
      window.removeEventListener('resize', applyLayout);
      window.removeEventListener('orientationchange', applyLayout);
    },
  };
}
